// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1J6jF","colCheckbox":"styles_colCheckbox__ZZ3QD"};